export interface RememberedUser {
	email: string;
	name: string;
}

const COOKIE_NAME = "remembered_user";
const MAX_AGE_DAYS = 30;

export const setRememberedUser = ({ email, name }: RememberedUser): void => {
	try {
		const value = encodeURIComponent(JSON.stringify({ email, name }));
		const maxAge = MAX_AGE_DAYS * 24 * 60 * 60;
		document.cookie = `${COOKIE_NAME}=${value}; max-age=${maxAge}; path=/; secure; samesite=lax`;
	} catch {
		// Cookie write failed — non-fatal.
	}
};

export const getRememberedUser = (): RememberedUser | null => {
	try {
		const match = document.cookie
			.split("; ")
			.find((row) => row.startsWith(`${COOKIE_NAME}=`));
		if (!match) return null;

		const raw = decodeURIComponent(match.split("=").slice(1).join("="));
		const parsed = JSON.parse(raw);
		if (parsed && typeof parsed.email === "string" && typeof parsed.name === "string") {
			return parsed as RememberedUser;
		}
		return null;
	} catch {
		return null;
	}
};

export const clearRememberedUser = (): void => {
	try {
		document.cookie = `${COOKIE_NAME}=; max-age=0; path=/; secure; samesite=lax`;
	} catch {
		// non-fatal
	}
};
